module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"description-all":"Pela configuração atual, todos com acesso ao álbum poderão ver todas as fotos.","description-own":"Pela configuração atual, aqueles com acesso ao álbum só verão fotos em que eles e seus dependentes apareçam."}}')
  delete Component.options._Ctor
}
